import React from 'react'
import { ProgressBar } from "primereact/progressbar";
import "./Avance.scss"
function Avance({ itemu, item, listaProgresoLeccionUnidadeCursoPrograma, listaLeccionUnidadeCursoPrograma, listaEvaluacionesUnidadeCursoPrograma, i }) {
    function ProgresoProgramaCursoUnidadPormedioProgressBar(props) {
        if (listaProgresoLeccionUnidadeCursoPrograma != null) {
            var Sum = listaProgresoLeccionUnidadeCursoPrograma
                .filter(
                    (x) => x.idCurso === props.idCurso && x.idUnidad === props.idUnidad
                )
                .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
            var LeccionesPorUnidad = listaLeccionUnidadeCursoPrograma.filter(
                (x) => x.idUnidad === props.idUnidad
            );
            var auxListadeLeccionesPorUnidad = [];
            for (var j = 0; j < LeccionesPorUnidad.length; j++) {
                auxListadeLeccionesPorUnidad.push(LeccionesPorUnidad[j]);
            }
            const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length;
            return (
                <ProgressBar
                    className={"ProgressBar" + props.idUnidad}
                    style={{ height: "8px", borderRadius: 0 }}
                    value={PorcentajeCurso.toFixed(2)}
                ></ProgressBar>
            );
        } else {
            return (
                <ProgressBar
                    className={"ProgressBar" + props.idUnidad}
                    style={{ height: "8px", borderRadius: 0 }}
                    value={0}
                ></ProgressBar>
            );
        }
    }

    function ProgresoProgramaCursoUnidadPormedio(props) {
        if (listaProgresoLeccionUnidadeCursoPrograma != null) {
            var Sum = listaProgresoLeccionUnidadeCursoPrograma
                .filter(
                    (x) => x.idCurso === props.idCurso && x.idUnidad === props.idUnidad
                )
                .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
            var LeccionesPorUnidad = listaLeccionUnidadeCursoPrograma.filter(
                (x) => x.idUnidad === props.idUnidad
            );
            var auxListadeLeccionesPorUnidad = [];
            for (var j = 0; j < LeccionesPorUnidad.length; j++) {
                auxListadeLeccionesPorUnidad.push(LeccionesPorUnidad[j]);
            }
            const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length;
            return <span style={{ color: "blue" }}>{Math.round(PorcentajeCurso)}%</span>;
        } else {
            return <span style={{ color: "blue" }}>0%</span>;
        }
    }

    function UnidadEvaluacion(props) {
        if (listaEvaluacionesUnidadeCursoPrograma) {
            var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
                (x) => x.idUnidad === props.idUnidad
            );
            if (evaluacionesUnidad.length > 0) {
                const notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
                const notaMasAlta = Math.max(...notas);
                return (
                    <span className="fontsizesmall Evaluacion1">
                        Evaluación: {" "}
                        <span style={notaMasAlta <= 9 ? { color: "red" } : { color: "black" }}>
                            {notaMasAlta <= 9 ? "0" + notaMasAlta : notaMasAlta}
                        </span>
                    </span>
                );
            } else {
                return <span className="fontsizesmall Evaluacion1">Evaluación: --</span>;
            }
        } else {
            return <span className="fontsizesmall Evaluacion1">Evaluación: --</span>;
        }
    }

    return (
        <div>
            <div className="p-fluid formgrid grid ">
                <div className="field col-12 md:col-3 contenedor__avance" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} >
                    <b className="">
                        {"Unidad " + (i + 1)}
                    </b>
                </div>
                <div className="field col-5 md:col-5 avance_progreso_barra">

                    <ProgresoProgramaCursoUnidadPormedioProgressBar
                        idCurso={item.idCurso}
                        idUnidad={itemu.idUnidad}
                    />
                </div>

                <div className="field col-2 md:col-1 avance_progreso_porcentaje ">
                    <ProgresoProgramaCursoUnidadPormedio
                        idCurso={item.idCurso}
                        idUnidad={itemu.idUnidad}
                    />
                </div>
                <div className="field col-5 md:col-3 avance_progreso_promedio ">
                    <UnidadEvaluacion
                        idUnidad={itemu.idUnidad}
                    />
                </div>
            </div>
        </div>
    )
}

export default Avance